import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'

export const SearchButton = styled(TextButton)`
  flex: 1 1 100%;
  width: 100%;

  ${mediaQueryUp.tablet} {
    &:not(.compact) {
      flex: 0 1 auto;
      width: auto;
    }
  }
`
